import {useMemo} from 'react'
import {IconButton, Box, Tooltip} from '@mui/material'
import OpenInFullRounded from '@mui/icons-material/OpenInFullRounded'
import {useNavigate} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {useAppTokens} from '../../theme'
import type {ThemeTokens} from '../../theme'

// ── MaximizeToolbar — opens the standalone /free editor, preserving state ──

const MaximizeToolbar = () => {
  const tokens = useAppTokens()
  const navigate = useNavigate()
  const {t} = useTranslation()

  const handleMaximize = () => navigate('/free')

  const sx = useMemo(() => buildStyles(tokens), [tokens])

  return (
    <Box sx={sx.root}>
      <Tooltip title={t('topBar.openFullEditor')} placement="bottom">
        <IconButton size="small" onClick={handleMaximize} sx={sx.button}>
          <OpenInFullRounded sx={sx.icon} />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

const buildStyles = (tokens: ThemeTokens) => ({
  root: {
    position: 'absolute' as const,
    top: 12,
    right: 12,
    zIndex: 20,
    display: 'flex',
    alignItems: 'center',
    padding: '4px 6px',
    borderRadius: '10px',
    backgroundColor: tokens.surface.glass,
    backdropFilter: 'blur(12px)',
    border: `1px solid ${tokens.accordion.border}`,
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.3)',
  },
  button: {
    color: 'rgba(255, 255, 255, 0.75)',
    '&:hover': {
      color: 'rgba(255, 255, 255, 0.95)',
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
  icon: {
    fontSize: 18,
  },
})

export default MaximizeToolbar
